<template>
    <div>
        <h1 style="font-size: 24px; color: black;">反馈列表</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="项目：">
                    <el-select v-model="queryData.appId" placeholder="请选择"  >
                        <el-option
                                v-for="item in iosAppList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="反馈ID：">
                    <el-input  placeholder="请输入内容"  v-model="queryData.id" ></el-input>
                </el-form-item>
                <el-form-item label="用户DID：">
                    <el-input  placeholder="请输入内容"  v-model="queryData.did" ></el-input>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="queryData.state" placeholder="请选择"  >
                        <el-option v-for="state in states"
                                   :key="state.id"
                                   :label="state.name"
                                   :value="state.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="queryFeedback">查询</el-button>
                    <el-button @click="reset">重置</el-button>
                    <el-button type="success" @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="feedback"
                      style="width: 100%"
                      border
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="应用" prop="appType" >
                    <template slot-scope="scope">
                        {{ scope.row.app_id | commonFilter(iosAppObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="用户UID" prop="uid" align="center"></el-table-column>
                <el-table-column label="联系方式" prop="contact" align="center"></el-table-column>
                <el-table-column label="用户设备码" prop="did" align="center"></el-table-column>
                <el-table-column label="反馈ID" prop="id" align="center"></el-table-column>
<!--                <el-table-column label="反馈内容"  align="center" show-overflow-tooltip>
                    <template slot-scope="scope" >
                        {{ scope.row.suggest !==null ? scope.row.suggest:"暂无"}}
                      <el-button
                          v-if="scope.row.suggest"
                          type="text"
                          size="small"
                          @click="copyContent(scope.row.suggest)"
                          style="margin-left: 10px;"
                      >
                        复制
                      </el-button>
                    </template>
                </el-table-column>-->
              <el-table-column label="反馈内容" align="center" width="300" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                            <span style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                {{ scope.row.suggest !== null ? scope.row.suggest : "暂无" }}
                            </span>
                    <el-button
                        v-if="scope.row.suggest"
                        type="text"
                        size="small"
                        @click="copyContent(scope.row.suggest)"                                style="margin-left: 8px; flex-shrink: 0;"
                    >
                      复制
                    </el-button>
                  </div>
                </template>
              </el-table-column>
<!--          start-->
              <!-- 新增图片列 -->
              <el-table-column label="反馈图片" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgs && scope.row.imgs.trim()" @click="openImageDialog(scope.row.imgs)">
                    <!-- 显示第一张图片作为缩略图 -->
                    <img
                        :src="getFirstImageUrl(scope.row.imgs)"
                        style="width: 80px; height: 80px; object-fit: cover; cursor: pointer; border-radius: 4px;"
                        alt="反馈图片"
                    >
                    <span v-if="getImageList(scope.row.imgs).length > 1"
                          style="color: #409EFF; font-size: 12px; margin-left: 5px;">
                                共{{getImageList(scope.row.imgs).length}}张
                            </span>
                  </div>
                  <span v-else>暂无</span>
                </template>
              </el-table-column>


<!--              end-->
                <el-table-column label="手机品牌"  align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.ph !==null ? scope.row.ph:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="手机型号" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.pt !==null ? scope.row.pt:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="手机系统"  align="center" >
                    <template slot-scope="scope" >
                        {{ scope.row.sv !==null ? scope.row.sv:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="网络环境"  align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.nt !==null ? scope.row.nt:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="版本号" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.version_code !==null ? scope.row.version_code:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="版本名" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.version_name !==null ? scope.row.version_name:"暂无"}}
                    </template>
                </el-table-column>
<!--                <el-table-column label="包名" align="center">-->
<!--                    <template slot-scope="scope" >-->
<!--                        {{ scope.row.pack !==null ? scope.row.pack:"暂无"}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="子渠道" align="center">-->
<!--                    <template slot-scope="scope" >-->
<!--                        {{ scope.row.scid !==null ? scope.row.scid:"暂无"}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope" >
                        <el-button v-if="scope.row.state===0" type="primary" plain @click="updateState(scope.row.id,1)">待处理</el-button>
                        <el-button v-if="scope.row.state===1" plain disabled>已处理</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center">
                    <template slot-scope="scope" >
                        {{formatDate(scope.row.create_dt,"yyyy-MM-DD HH:mm:ss")}}
                    </template>
                </el-table-column>
            </el-table>
        </div>

      <!-- 图片预览弹窗 -->
      <el-dialog
          title="图片预览"
          :visible.sync="imageDialogVisible"
          width="50%"
          append-to-body
          :close-on-click-modal="false"
          class="image-preview-dialog">
        <div v-if="imageList.length" class="image-preview-container">
          <!-- 当前图片 -->
          <div class="image-wrapper">
            <img
                :src="imageList[currentIndex]"
                class="preview-image"
                alt="预览图片">
          </div>

          <!-- 左右切换按钮 -->
          <button class="prev-btn" @click="prevImage" v-if="imageList.length > 1">❮</button>
          <button class="next-btn" @click="nextImage" v-if="imageList.length > 1">❯</button>

          <!-- 功能按钮组 -->
          <div class="action-buttons">
            <el-button type="primary" @click="copyImage" icon="document-copy">
              复制图片
            </el-button>
            <el-button @click="downloadImage" icon="download">
              下载图片
            </el-button>
          </div>

          <!-- 图片索引 -->
          <div class="image-index">
            {{ currentIndex + 1 }} / {{ imageList.length }}
          </div>
        </div>
        <div v-else style="text-align: center; padding: 50px;">
          暂无图片
        </div>
      </el-dialog>


        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        downloadData,
        feedbackSearch,
        feedbackUpdate
    } from "@/http/api";
    import settingMix from '@/utils/mix/common-setting'
    import utils from '@/utils';
    export default {
        name: "Feedback",
        mixins: [settingMix],
        data(){
            return{
                position:0,
                needIosApp: true,
                iosAppObj: {},
                iosAppList: [],
                queryData:{
                    did:'',
                    appId: 12,
                    timeDate:['',''],
                    id:'',
                    state: -1,
                    contact:'',
                    isExport:0,
                    orders:'create_dt desc',
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                feedback:[],
                loading:true,
                states:[
                    {id:-1,name:'全部'},
                    {id:0,name:'待处理'},
                    {id:1,name:'已处理'}
                ],
              imageDialogVisible: false,
              imageList: [],
              currentIndex: 0,
              isDragging: false,
              startX: 0,
              startY: 0,
              scrollLeft: 0,
              scrollTop: 0
            }
        },
        methods:{
          // ... existing code ...

          copyContent(content) {
            if (!content) return;

            const textarea = document.createElement('textarea');
            textarea.value = content;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();

            try {
              document.execCommand('copy');
              this.$message.success('复制成功');
            } catch (err) {
              this.$message.error('复制失败');
            }

            document.body.removeChild(textarea);
          },

          // ... existing code ...

            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryFeedback();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryFeedback();
            },
            updateState(id,state){
                this.$confirm('确认是否通过?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    feedbackUpdate(id,state).then(resp=> {
                        if (resp.data.status===0){
                            this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                            this.queryFeedback();
                        }else{
                            this.$message({
                                message: "操作失败",
                                type: 'error'
                            });
                        }
                    })
                })
            },
            queryFeedback(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.queryData.isExport = 0;
                const numReg = /^[0-9]*$/;
                const numRe = new RegExp(numReg);
                let _message = '';
                if(!numRe.test(this.queryData.id)){
                    _message ="反馈id为数字，请输入数字! "
                }
                if (_message) {
                    this.$message({
                        type: 'error',
                        message: _message,
                    });
                    return false
                }
                this.loading = true;
                feedbackSearch(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.feedback=resp.data.info.list;
                        this.page.totalElements =resp.data.info.totalElements;
                    }
                });
            },
            reset(){
                    this.queryData.appId = 12;
                    this.queryData.did = '';
                    this.queryData.timeDate=['',''];
                    this.queryData.id='';
                    this.queryData.state=-1;
                    this.queryData.contact='';
                    this.queryData.isExport=0;
                    this.queryData.orders='create_dt desc';
            },
            exportExcel() {
                let fileName;
                    fileName  = new Date().toLocaleString() + '_ios反馈.xlsx';
                this.queryData.isExport = 1;
                downloadData(
                    '/feedback/exportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            },
          // 新增方法：处理图片URL列表
          getImageList(imgsStr) {
            if (!imgsStr) return [];
            // 核心修改：在filter后通过map拼接域名，同时处理URL已包含域名的情况
            return imgsStr.split(',')
                .filter(img => img && img.trim()) // 过滤空值和纯空格
                .map(img => {
                  const trimedImg = img.trim();
                  // 避免重复拼接域名（如果URL已包含该域名则直接返回）
                  const domain = 'https://cdn.gameley.cn/';
                  return trimedImg.startsWith(domain) ? trimedImg : domain + trimedImg;
                });
          },
          // 新增方法：获取第一张图片URL
          getFirstImageUrl(imgsStr) {
            const list = this.getImageList(imgsStr);
            return list.length > 0 ? list[0] : '';

          },
          // 新增方法：打开图片预览弹窗
          openImageDialog(imgsStr) {
            this.imageList = this.getImageList(imgsStr);
            this.imageDialogVisible = true;
            this.currentIndex = 0;
          },

          // 上一张
          prevImage() {
            if (this.currentIndex > 0) {
              this.currentIndex--;
            } else {
              this.currentIndex = this.imageList.length - 1;
            }
          },

          // 下一张
          nextImage() {
            if (this.currentIndex < this.imageList.length - 1) {
              this.currentIndex++;
            } else {
              this.currentIndex = 0;
            }
          },

          // 鼠标拖动开始
          startDrag(e) {
            this.isDragging = true;
            this.startX = e.pageX;
            this.startY = e.pageY;
            const img = this.$refs.previewImage;
            this.scrollLeft = img.scrollLeft;
            this.scrollTop = img.scrollTop;
            img.style.cursor = 'grabbing';
          },

          // 鼠标拖动中
          onDrag(e) {
            if (!this.isDragging) return;
            e.preventDefault();
            const img = this.$refs.previewImage;
            const walkX = (e.pageX - this.startX) * 2;
            const walkY = (e.pageY - this.startY) * 2;
            img.scrollLeft = this.scrollLeft - walkX;
            img.scrollTop = this.scrollTop - walkY;
          },

          // 鼠标拖动结束
          endDrag() {
            this.isDragging = false;
            if (this.$refs.previewImage) {
              this.$refs.previewImage.style.cursor = 'grab';
            }
          },

          // 触摸开始（移动端）
          handleTouchStart(e) {
            const touch = e.touches[0];
            this.startX = touch.clientX;
            this.startY = touch.clientY;
            this.isDragging = true;
          },

          // 触摸移动（移动端）
          handleTouchMove(e) {
            if (!this.isDragging) return;
            e.preventDefault();
            const touch = e.touches[0];
            const img = this.$refs.previewImage;
            const walkX = (this.startX - touch.clientX) * 2;
            const walkY = (this.startY - touch.clientY) * 2;
            img.scrollLeft += walkX;
            img.scrollTop += walkY;
            this.startX = touch.clientX;
            this.startY = touch.clientY;
          },

          // 触摸结束（移动端）
          handleTouchEnd() {
            this.isDragging = false;
            // 判断滑动方向，切换图片
            const img = this.$refs.previewImage;
            if (img.scrollLeft > 100) {
              this.prevImage();
            } else if (img.scrollLeft < -100) {
              this.nextImage();
            }
            img.scrollLeft = 0;
            img.scrollTop = 0;
          },

          // 复制图片
          async copyImage() {
            try {
              const imgUrl = this.imageList[this.currentIndex];
              const response = await fetch(imgUrl);
              const blob = await response.blob();

              if (navigator.clipboard && navigator.clipboard.write) {
                // eslint-disable-next-line no-undef
                await navigator.clipboard.write([
                  // eslint-disable-next-line no-undef
                  new ClipboardItem({ [blob.type]: blob })
                ]);
                this.$message.success('图片已复制到剪贴板！');
              } else {
                this.fallbackCopy();
              }
            } catch (err) {
              console.error('复制失败:', err);
              this.fallbackCopy();
            }
          },

          // 降级复制方案
          fallbackCopy() {
            this.$prompt('长按图片可保存到相册', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'info'
            });
          },

          // 下载图片
          downloadImage() {
            const link = document.createElement('a');
            link.href = this.imageList[this.currentIndex];
            link.download = `feedback_${this.currentIndex + 1}.jpg`;
            link.click();
            this.$message.success('图片已开始下载！');
          }
        },
        created () {
            this.queryFeedback();
        }
    }
</script>

<style scoped>
    .sub-sub11{ position: relative; left: 100px;}

    /* 图片预览弹窗样式 */
    ::v-deep .image-preview-dialog .el-dialog__body {
      padding: 0;
      height: 500px;
      position: relative;
    }

    .image-preview-container {
      position: relative;
      width: 100%;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .image-wrapper {
      width: 100%;
      height: 450px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .preview-image {
      max-width: 90%;
      max-height: 400px;
      object-fit: contain;
      user-select: none;
    }

    /* 切换按钮样式 - 垂直居中 */
    .prev-btn, .next-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.6);
      color: white;
      border: none;
      width: 40px;
      height: 40px;
      cursor: pointer;
      font-size: 18px;
      border-radius: 4px;
      z-index: 10;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .prev-btn:hover, .next-btn:hover {
      background: rgba(0, 0, 0, 0.9);
      transform: translateY(-50%) scale(1.1);
    }

    .prev-btn {
      left: 20px;
    }

    .next-btn {
      right: 20px;
    }

    /* 功能按钮组 */
    .action-buttons {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      display: flex;
      gap: 10px;
    }

    .image-index {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      color: white;
      background: rgba(0, 0, 0, 0.6);
      padding: 6px 12px;
      border-radius: 15px;
      font-size: 13px;
      z-index: 10;
    }

    /* 轮播指示器样式 */
    ::v-deep .el-carousel__indicator {
      width: 12px;
      height: 12px;
    }
    ::v-deep .el-carousel__indicator--active {
      background-color: #409EFF;
    }
</style>
